/**
 * StatusMx.js
 *
 * @description :: A model definition.  Represents a database table/collection/etc.
 * @docs        :: https://sailsjs.com/docs/concepts/models-and-orm/models
 */

 export default {

    // tableName: 'servicetypecatalogletter',
  
    attributes: {
  
      id: {
        type: 'number',
        required: true,
        unique: true,
        columnName: 'id'
      },

      name: {
        type: 'string',
        required: true,
      },
  
    },
  
  }
  
  


// WEBPACK FOOTER //
// ./src/models/ServiceTypeCatalogLetter.js